import { Container, Row, Col } from "react-bootstrap";
import { FaXTwitter, FaYoutube, FaBluesky } from "react-icons/fa6";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <footer className="footer">
    <Container fluid>
      <Row>
        <Col md="4" className="footer-copyright">
          <h3>© {year} Hotkey Clicker Games</h3>
        </Col>
        <Col md="2" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://x.com/HotkeyClicker"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaXTwitter />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.youtube.com/@hotkeyclicker"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaYoutube />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://bsky.app/profile/hotkeyclicker.bsky.social"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaBluesky />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
    </footer>
  );
}

export default Footer;
